import { c as _c } from "react/compiler-runtime";
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { COURSE_THEMES_API } from '../constants/course-themes-api';
import { CourseThemeInterface } from '../types/course-theme-interface';
function useCourseThemes() {
  const $ = _c(4);
  const {
    data: themes
  } = useSWR(_temp, baseFetcher);
  let t0;
  if ($[0] !== themes) {
    t0 = themes?.filter(_temp2).sort(_temp3);
    $[0] = themes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const preparedThemes = t0;
  let t1;
  if ($[2] !== preparedThemes) {
    t1 = {
      themes: preparedThemes
    };
    $[2] = preparedThemes;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp3(a, b) {
  return a.id - b.id;
}
function _temp2(theme) {
  return !!theme.id;
}
function _temp() {
  return COURSE_THEMES_API;
}
export default useCourseThemes;